(function () {
  'use strict';

  if (!location.pathname.startsWith('/a/subscriptions/manage/')) return;

  var PROXY_URL = 'https://grns-insights-hub.vercel.app/api/seal-proxy';

  var ADDONS = [
    {
      key: 'tub',
      product_id: '7123550961745',
      title: 'GRNS Daily Super Greens',
      price: 68.50,
      comparePrice: 85.00,
      quantity: 1,
      label: 'Greens Tub',
      detail: '250g · 30 serves',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/122.webp?v=1778896174',
      defaultOneTime: false,
      variants: [
        { label: 'Natural', variant_id: '59228685172817', sku: 'GRN-GP-250-ORG-1', title: 'GRNS Natural' },
        { label: 'Mango', variant_id: '59228685205585', sku: 'GRN-GP-250-MP-2', title: 'GRNS Mango/Passionfruit' }
      ]
    },
    {
      key: 'daily_sachet',
      product_id: '15703678091345',
      title: 'Daily Sachets',
      price: 99.95,
      comparePrice: null,
      quantity: 1,
      label: 'Daily Sachets',
      detail: '30-pack',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/Nutritional_Label_72.webp?v=1771545403',
      defaultOneTime: true,
      variants: [
        { label: 'Natural', variant_id: '59228704735313', sku: 'GRNS TRVL 30 NAT', title: 'GRNS Natural Daily Sachets' },
        { label: 'Mango', variant_id: '59228704768081', sku: 'GRNS TRVL 30 NAT-2', title: 'GRNS Mango/Passionfruit Daily Sachets' }
      ]
    },
    {
      key: 'sachet',
      product_id: '7774652006481',
      title: 'Travel Sachets',
      price: 7.99,
      comparePrice: 19.99,
      quantity: 1,
      label: 'Travel Sachets',
      detail: '2× pack',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/gempages_489095260442461323-54515ca1-fbd7-4c5f-bfe6-7f048251e639.webp?v=1747866450',
      defaultOneTime: true,
      variants: [
        { label: 'Natural', variant_id: '59228793405521', sku: 'GRN-SACHET', title: 'GRNS Natural Sachets' },
        { label: 'Mango', variant_id: '59228793438289', sku: 'GRN-SACHET-2', title: 'GRNS Mango/Passionfruit Sachets' }
      ]
    },
    {
      key: 'bottle',
      product_id: '7774651711569',
      variant_id: '42398899601489',
      title: 'Premium Glass Bottle',
      sku: 'GRN-BOTTLE',
      price: 19.99,
      comparePrice: 29.99,
      quantity: 1,
      label: 'Glass Bottle',
      detail: '500ml',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/GRNS_169_ads_1080_x_1080_px_29.webp?v=1771737940',
      defaultOneTime: true
    },
    {
      key: 'tumbler',
      product_id: '15570902384721',
      variant_id: '58283630690385',
      title: 'Travel Tumbler (Free Shipping)',
      sku: 'DPGRNTUMBLER',
      price: 34.99,
      comparePrice: 39.99,
      quantity: 1,
      label: 'Travel Tumbler',
      detail: '40oz',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/Nutritional_Label_53.webp?v=1767417812',
      defaultOneTime: true
    },
    {
      key: 'spoon',
      product_id: '15732349435985',
      variant_id: '59228861923409',
      title: 'Metal Scoop',
      sku: 'SPOON-MET',
      price: 3.99,
      comparePrice: 4.99,
      quantity: 1,
      label: 'Metal Scoop',
      detail: 'Stainless steel',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/NutritionalLabel_7.webp?v=1774319376',
      defaultOneTime: true
    }
  ];

  function preloadImages() {
    ADDONS.forEach(function(a) {
      var img = new Image();
      img.src = a.image;
    });
  }

  function getSubscriptionId() {
    var parts = location.pathname.split('/');
    var idx = parts.indexOf('manage');
    if (idx === -1 || !parts[idx + 1]) return null;
    return parseInt(parts[idx + 1], 36);
  }

  function doAdd(addon, variantId, sku, title, isOneTime, btn, card) {
    var subId = getSubscriptionId();
    if (!subId) return;

    btn.disabled = true;
    btn.textContent = 'Adding';
    btn.classList.add('grns-addon-card__btn--loading');

    fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: subId,
        action: 'add_items',
        add_items: [{
          product_id: addon.product_id,
          variant_id: variantId,
          quantity: addon.quantity,
          title: title,
          sku: sku,
          price: addon.price,
          taxable: 1,
          requires_shipping: 0,
          one_time: isOneTime ? 1 : 0,
          properties: []
        }]
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.error || data.errors) {
        btn.disabled = false;
        btn.textContent = 'Add';
        btn.classList.remove('grns-addon-card__btn--loading');
        console.error('GRNS addon error:', data);
        return;
      }
      btn.classList.remove('grns-addon-card__btn--loading');
      btn.textContent = 'Added ✓';
      btn.style.background = '#4a7a3a';
      card.classList.add('grns-addon-card--added');
      sessionStorage.setItem('grns_portal_reloading', '1');
      location.reload();
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.textContent = 'Add';
      btn.classList.remove('grns-addon-card__btn--loading');
      console.error('GRNS addon error:', err);
    });
  }

  function buildCard(addon) {
    var card = document.createElement('div');
    card.className = 'grns-addon-card';

    var hasVariants = addon.variants && addon.variants.length > 0;
    var oneTimeActive = addon.defaultOneTime !== false;

    var variantsHtml = '';
    if (hasVariants) {
      variantsHtml = '<div class="grns-addon-card__variants">';
      addon.variants.forEach(function(v, i) {
        variantsHtml += '<button class="grns-addon-card__var-btn' + (i === 0 ? ' grns-addon-card__var-btn--active' : '') + '" data-variant-id="' + v.variant_id + '" data-sku="' + v.sku + '" data-title="' + (v.title || '') + '" type="button">' + v.label + '</button>';
      });
      variantsHtml += '</div>';
    }

    card.innerHTML =
      '<img class="grns-addon-card__img" src="' + addon.image + '" alt="' + addon.label + '">' +
      '<div class="grns-addon-card__info">' +
        '<div class="grns-addon-card__price">' +
          '$' + addon.price.toFixed(2) +
          (addon.comparePrice && addon.comparePrice > addon.price ? '<span class="grns-addon-card__compare">$' + addon.comparePrice.toFixed(2) + '</span>' : '') +
        '</div>' +
        '<div class="grns-addon-card__label">' + addon.label + ' <span class="grns-addon-card__members">(Members Pricing)</span></div>' +
        '<div class="grns-addon-card__detail">' + addon.detail + '</div>' +
        variantsHtml +
        '<div class="grns-addon-card__freq">' +
          '<button class="grns-addon-card__freq-btn' + (oneTimeActive ? ' grns-addon-card__freq-btn--active' : '') + '" data-onetime="1" type="button">One Time</button>' +
          '<button class="grns-addon-card__freq-btn' + (!oneTimeActive ? ' grns-addon-card__freq-btn--active' : '') + '" data-onetime="0" type="button">Every Renewal</button>' +
        '</div>' +
      '</div>' +
      '<button class="grns-addon-card__btn" type="button">Add</button>';

    if (hasVariants) {
      var varBtns = card.querySelectorAll('.grns-addon-card__var-btn');
      varBtns.forEach(function(vb) {
        vb.addEventListener('click', function() {
          varBtns.forEach(function(b) { b.classList.remove('grns-addon-card__var-btn--active'); });
          vb.classList.add('grns-addon-card__var-btn--active');
        });
      });
    }

    var freqBtns = card.querySelectorAll('.grns-addon-card__freq-btn');
    freqBtns.forEach(function(fb) {
      fb.addEventListener('click', function() {
        freqBtns.forEach(function(b) { b.classList.remove('grns-addon-card__freq-btn--active'); });
        fb.classList.add('grns-addon-card__freq-btn--active');
      });
    });

    var btn = card.querySelector('.grns-addon-card__btn');
    btn.addEventListener('click', function () {
      var activeFreq = card.querySelector('.grns-addon-card__freq-btn--active');
      var isOneTime = activeFreq ? activeFreq.getAttribute('data-onetime') === '1' : true;

      var variantId = addon.variant_id || '';
      var sku = addon.sku || '';
      var title = addon.title || '';
      if (hasVariants) {
        var activeVar = card.querySelector('.grns-addon-card__var-btn--active');
        if (activeVar) {
          variantId = activeVar.getAttribute('data-variant-id');
          sku = activeVar.getAttribute('data-sku');
          title = activeVar.getAttribute('data-title') || title;
        }
      }

      doAdd(addon, variantId, sku, title, isOneTime, btn, card);
    });

    return card;
  }

  function buildImageMap() {
    var map = {};
    ADDONS.forEach(function(addon) {
      if (addon.variants) {
        addon.variants.forEach(function(v) {
          if (v.title) map[v.title.toLowerCase()] = addon.image;
        });
      }
      if (addon.title) map[addon.title.toLowerCase()] = addon.image;
    });
    return map;
  }

  function injectItemImages() {
    var imgMap = buildImageMap();
    var allEls = document.querySelectorAll('p, span, div, td, li');
    for (var i = 0; i < allEls.length; i++) {
      var el = allEls[i];
      if (el.children.length > 0) continue;
      var text = el.textContent.trim().toLowerCase();
      var imgSrc = imgMap[text];
      if (!imgSrc) continue;

      var row = el.parentNode;
      for (var j = 0; j < 5; j++) {
        if (!row || row === document.body) { row = null; break; }
        if (row.textContent.indexOf('$') > -1) break;
        row = row.parentNode;
      }
      if (!row || row === document.body) continue;
      if (row.querySelector('.grns-item-img')) continue;

      var checkParent = row.parentNode;
      if (row.querySelector('img') || (checkParent && checkParent.querySelector('img'))) continue;

      var img = document.createElement('img');
      img.className = 'grns-item-img';
      img.src = imgSrc;
      img.alt = el.textContent.trim();
      row.insertBefore(img, row.firstChild);
    }
  }

  function styleOneTimeBadges() {
    var candidates = document.querySelectorAll('span, div, p, label, small');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent.trim() === 'One-time purchase') {
        el.style.setProperty('background', '#e8f5e2', 'important');
        el.style.setProperty('color', '#2d6a1f', 'important');
        el.style.setProperty('border-color', '#c8e6c0', 'important');
      }
    }
  }

  function enhance() {
    styleOneTimeBadges();
    injectItemImages();
  }

  function cloneWithSync(section) {
    var clone = section.cloneNode(true);

    var origVarBtns = section.querySelectorAll('.grns-addon-card__var-btn');
    var cloneVarBtns = clone.querySelectorAll('.grns-addon-card__var-btn');
    cloneVarBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        origVarBtns[i].click();
        var card = btn.closest('.grns-addon-card');
        card.querySelectorAll('.grns-addon-card__var-btn').forEach(function(b) {
          b.classList.remove('grns-addon-card__var-btn--active');
        });
        btn.classList.add('grns-addon-card__var-btn--active');
      });
    });

    var origFreqBtns = section.querySelectorAll('.grns-addon-card__freq-btn');
    var cloneFreqBtns = clone.querySelectorAll('.grns-addon-card__freq-btn');
    cloneFreqBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        origFreqBtns[i].click();
        var card = btn.closest('.grns-addon-card');
        card.querySelectorAll('.grns-addon-card__freq-btn').forEach(function(b) {
          b.classList.remove('grns-addon-card__freq-btn--active');
        });
        btn.classList.add('grns-addon-card__freq-btn--active');
      });
    });

    var origAddBtns = section.querySelectorAll('.grns-addon-card__btn');
    var cloneAddBtns = clone.querySelectorAll('.grns-addon-card__btn');
    cloneAddBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        var origBtn = origAddBtns[i];
        btn.disabled = true;
        btn.textContent = 'Adding';
        btn.classList.add('grns-addon-card__btn--loading');
        origBtn.click();
        var observer = new MutationObserver(function() {
          if (origBtn.textContent === 'Added ✓') {
            btn.classList.remove('grns-addon-card__btn--loading');
            btn.textContent = 'Added ✓';
            btn.style.background = '#4a7a3a';
            btn.closest('.grns-addon-card').classList.add('grns-addon-card--added');
            observer.disconnect();
          } else if (!origBtn.disabled) {
            btn.disabled = false;
            btn.textContent = 'Add';
            btn.classList.remove('grns-addon-card__btn--loading');
            observer.disconnect();
          }
        });
        observer.observe(origBtn, { attributes: true, childList: true, characterData: true, subtree: true });
      });
    });

    return clone;
  }

  function inject() {
    document.documentElement.classList.remove('grns-portal-loading');
    if (document.querySelector('.grns-addon-section')) return;
    if (!getSubscriptionId()) return;

    var section = document.createElement('div');
    section.className = 'grns-addon-section grns-addon-section--desktop';

    var heading = document.createElement('p');
    heading.className = 'grns-addon-section__heading';
    heading.textContent = 'Add to next renewal';
    section.appendChild(heading);

    var memberNote = document.createElement('p');
    memberNote.className = 'grns-addon-section__note';
    memberNote.textContent = 'Exclusive member pricing — only available as an add-on to your existing subscription. Not available for one-off purchases.';
    section.appendChild(memberNote);

    var grid = document.createElement('div');
    grid.className = 'grns-addon-grid';
    ADDONS.forEach(function (addon) {
      grid.appendChild(buildCard(addon));
    });
    section.appendChild(grid);

    var discountBox = document.querySelector('[data-discount-code-container]');
    if (discountBox && discountBox.parentNode) {
      discountBox.parentNode.insertBefore(section, discountBox);
    } else {
      var fallback =
        document.querySelector('.seal-oneThird') ||
        document.querySelector('main') ||
        document.body;
      fallback.appendChild(section);
    }

    var mobileSection = cloneWithSync(section);
    mobileSection.classList.remove('grns-addon-section--desktop');
    mobileSection.classList.add('grns-addon-section--mobile');

    var billingSection =
      document.querySelector('[data-billing-schedule]') ||
      document.querySelector('.seal-billing-schedule') ||
      (function() {
        var els = document.querySelectorAll('h2, h3, h4, p, div');
        for (var i = 0; i < els.length; i++) {
          if (els[i].textContent.trim() === 'Billing schedule') {
            return els[i].closest('[class*="seal-"]') || els[i].parentNode;
          }
        }
        return null;
      })();

    if (billingSection && billingSection.parentNode) {
      billingSection.parentNode.insertBefore(mobileSection, billingSection);
    }

    enhance();

    var observer = new MutationObserver(function() { enhance(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 5000);
  }

  document.addEventListener('sealsubs_portal:loaded', inject);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(inject, 300); });
  } else {
    setTimeout(inject, 300);
  }

  preloadImages();
})();
